export default {
    methods: {
        translate(key) {
            return this.$vuetify.lang.t(`$vuetify.${key}`);
        },
    },
};
